.rep-image-container {
    width: 120px;
    height: 88px;
    align-self: center;
    overflow: hidden;
    display: flex;
}

/* Match background color of each Sales rep image */
.rep-image-container--chad {
    justify-content: center;
    background-color: #ffda4e;
}

.rep-image-container--jared {
    background-color: #f8da69;
}

.register-button-container {
    display: flex;
    min-width: 170px;
    justify-content: flex-end;
}
